
export class FormUtilsService {

  static getDirtyValues(form: any): any {
    const dirtyValues = {};

    Object.keys(form.controls)
      .forEach(key => {
        const currentControl = form.controls[key];
        if (currentControl.dirty) {
          if (currentControl.controls) {
            dirtyValues[key] = this.getDirtyValues(currentControl);
          } else {
            dirtyValues[key] = currentControl.value;
          }
        }
      });

    return dirtyValues;
  }
  static hasOnlyKeys(dirtyValues, keys): boolean {
    let hasOtherKeys = false;
    Object.keys(dirtyValues)
      .forEach(key => {
        if (keys.indexOf(key) === -1) {
          hasOtherKeys = true;
        }
      });
    return !hasOtherKeys;
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/form-utils.service.ts